import { Clear, ExpandLess, ExpandMore, FilterList } from "@mui/icons-material";
import { Box, Chip, ClickAwayListener, IconButton, Popover, Stack } from "@mui/material";
import React, { Fragment, useState } from "react";
import { TextField } from "../Input";
import { useFlag } from "../utils";
export function Filter(props) {
    const { label, active, enableSearch, onSearch, onClear, fullWidth, variant, labels, onFilterClick, children } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen, clearOpen, toggleOpen] = useFlag(false);
    const [value, setValue] = useState("");
    function handleKeyDown(e) {
        if (onSearch) {
            if (e.key == "Enter") {
                onSearch(value);
                setValue("");
            }
        }
    }
    function handleSetOpen() {
        setOpen();
        if (onFilterClick)
            onFilterClick();
    }
    const hasActiveFilter = Boolean(active === null || active === void 0 ? void 0 : active.filter(node => Boolean(node)).length);
    return (React.createElement(Fragment, null,
        React.createElement(TextField, { variant: variant, label: label, onClick: enableSearch ? undefined : handleSetOpen, value: value, onChange: setValue, onKeyDown: handleKeyDown, fullWidth: fullWidth, InputProps: {
                startAdornment: (React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mr: 2 } },
                    React.createElement(IconButton, { edge: "start", onClick: enableSearch ? handleSetOpen : undefined },
                        React.createElement(FilterList, null)),
                    active)),
                endAdornment: (React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center" },
                    !hasActiveFilter && (React.createElement(Chip, { variant: "outlined", label: labels("none"), clickable: true, onClick: enableSearch ? handleSetOpen : undefined })),
                    hasActiveFilter && onClear && (React.createElement(IconButton, { onClick: onClear, title: labels("reset") },
                        React.createElement(Clear, null))),
                    React.createElement(IconButton, { onClick: toggleOpen, edge: "end" }, open ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)))),
                readOnly: !enableSearch,
                ref: setAnchorEl,
                placeholder: enableSearch ? labels("search") : undefined,
            } }),
        children && (React.createElement(Popover, { open: open, anchorEl: anchorEl, onClose: clearOpen, anchorOrigin: {
                horizontal: "left",
                vertical: "bottom",
            } },
            React.createElement(ClickAwayListener, { onClickAway: clearOpen },
                React.createElement(Box, { width: anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.clientWidth }, children))))));
}
//# sourceMappingURL=Filter.js.map